// import dashboard from './dashboard'
import main from './main'

// Array of sections
export default [...main]
